import { render } from "./ModalContacts.vue?vue&type=template&id=27e92829&scoped=true&ts=true"
import script from "./ModalContacts.vue?vue&type=script&lang=ts"
export * from "./ModalContacts.vue?vue&type=script&lang=ts"

import "./ModalContacts.vue?vue&type=style&index=0&id=27e92829&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e92829"]])

export default __exports__